const API_AVAILABLE = 'available';
const API_CLOSED = 'closed';
const API_EXCLUSIVITY = 'exclusivity';
const API_FULL = 'full';
const API_NO_FLIGHT = 'noFlight';
const API_NO_DEPARTURE = 'noDeparture';
const API_OPEN = 'open';
const API_SIBLING_SUMMER = 'siblingSummer';
const API_SIBLING_WINTER = 'siblingWinter';
const API_NOT_BOOKABLE = [
  API_CLOSED,
  API_EXCLUSIVITY,
  API_FULL,
  API_NO_DEPARTURE,
  API_SIBLING_SUMMER,
  API_SIBLING_WINTER,
];

export {
  API_AVAILABLE,
  API_CLOSED,
  API_EXCLUSIVITY,
  API_FULL,
  API_NO_FLIGHT,
  API_NO_DEPARTURE,
  API_NOT_BOOKABLE,
  API_OPEN,
  API_SIBLING_SUMMER,
  API_SIBLING_WINTER,
};
